import { createLucideIcon } from 'lucide-react';
export const PointsIcon = createLucideIcon('points', [
  [
    'path',
    {
      d: 'M12 11.3333C12 10.597 10.2091 10 8 10C5.7909 10 4 10.597 4 11.3333',
      key: '1wfevu',
    },
  ],
  [
    'path',
    {
      d: 'M12 11.3333C12 12.0697 10.2091 12.6667 8 12.6667C5.7909 12.6667 4 12.0697 4 11.3333',
      key: 'xkklwa',
    },
  ],
  [
    'path',
    {
      d: 'M12 11.3333L12.0001 16.6667C12.0001 17.403 10.2092 18 8.0001 18C5.7909 18 4.0001 17.403 4.0001 16.6667L4 11.3333',
      key: '1gil00',
    },
  ],
  [
    'path',
    {
      d: 'M12 14C12 14.7364 10.2091 15.3333 8 15.3333C5.7909 15.3333 4 14.7364 4 14',
      key: '16gvk0',
    },
  ],
  [
    'path',
    {
      d: 'M12 7.3509V12.7544',
      key: '1mti16',
    },
  ],
  [
    'path',
    {
      d: 'M20 10.0526C20 10.7987 18.2091 11.4035 16 11.4035C13.7909 11.4035 12 10.7987 12 10.0526',
      key: '1k0i0a',
    },
  ],
  [
    'path',
    {
      d: 'M20 12.7544C20 13.5005 18.2091 14.1053 16 14.1053C13.7909 14.1053 12 13.5005 12 12.7544',
      key: '1u52ap',
    },
  ],
  [
    'path',
    {
      d: 'M20 12.7544V15.6491C20 16.3952 18.2091 17 16 17C13.7909 17 12 16.3952 12 15.6491V12.7544',
      key: '1x7xx5',
    },
  ],
  [
    'path',
    {
      d: 'M20 7.3509C20 6.6048 18.2091 6 16 6C13.7909 6 12 6.6048 12 7.3509',
      key: '1gko6w',
    },
  ],
  [
    'path',
    {
      d: 'M20 7.3509C20 8.097 18.2091 8.7018 16 8.7018C13.7909 8.7018 12 8.097 12 7.3509',
      key: '10r3l4',
    },
  ],
  [
    'path',
    {
      d: 'M20 7.3509V12.7544',
      key: '1o6550',
    },
  ],
]);
